import { map } from '../map'

const createPolyline = opts => {
  const polyline = new google.maps.Polyline(opts)

  polyline.setMap(map)

  animateCircle(polyline);

  function animateCircle(line) {
      var count = 100;
      window.setInterval(function() {
        count -= 0.5

        var icons = line.get('icons');
        line.planePosition = count
        icons[0].offset = count + '%';
        line.set('icons', icons);

        if(count === 0)
          count = 100
    }, 30);

  }

  return polyline
}

export default createPolyline



// WEBPACK FOOTER //
// ./app/polylines/createPolyline.js